export enum AuctionActivityStatus {
    InActive = 0,
    Active = 1,
    DateChanged = 2,
    Postponed = 3,
}
